let pendingUndo: { url: string; expires: number } | undefined;

export function channelPathSegment(url: unknown): string {
  if (typeof url !== 'string' || !/^[A-Za-z0-9_-]{1,256}$/.test(url)) {
    throw new Error('Invalid channel identifier');
  }
  return encodeURIComponent(url);
}

export function registerArchiveUndo(url: string) {
  pendingUndo = { url, expires: Date.now() + 15000 };
}

export function consumeArchiveUndo(url: unknown): boolean {
  if (!pendingUndo || pendingUndo.url !== url) return false;
  const valid = pendingUndo.expires > Date.now();
  pendingUndo = undefined;
  return valid;
}
